import * as React from 'react';
const SvgChevronUp = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m10 8.774-3.56 3.56a.55.55 0 0 1-.384.178.53.53 0 0 1-.391-.177.54.54 0 0 1-.181-.387q0-.207.18-.387l3.871-3.87A.64.64 0 0 1 10 7.484q.26 0 .465.205l3.87 3.87q.173.174.177.373.005.2-.177.38a.54.54 0 0 1-.387.182.54.54 0 0 1-.387-.181z'
            />
        </g>
    </svg>
);
export default SvgChevronUp;
